import { useFormikContext } from "formik";
import { useWizard } from "react-use-wizard";

type UseFormikWizardOptions<T extends object> = {
  formikFields: (keyof T)[];
};

export function useFormikWizard<T extends object>({
  formikFields,
}: UseFormikWizardOptions<T>): ReturnType<typeof useWizard> {
  const wizard = useWizard();
  const { validateForm, setFieldTouched } = useFormikContext<T>();

  wizard.handleStep(async () => {
    const errors = await validateForm();

    for (const formikField of formikFields) {
      if (errors[formikField]) {
        setFieldTouched(String(formikField), true, false);

        throw new Error(
          `Formik validation error on the following field: ${String(formikField)}`,
        );
      }
    }
  });

  return wizard;
}
